import { render, staticRenderFns } from "./NextInvoices.vue?vue&type=template&id=95fefb90&"
import script from "./NextInvoices.vue?vue&type=script&lang=js&"
export * from "./NextInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports